var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.logs
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      [
        _c(
          "div",
          { staticClass: "log-wrap mb-3", attrs: { id: "accordion" } },
          _vm._l(_vm.logs, function(log) {
            return _c("div", { key: log.id }, [
              _c(
                "div",
                {
                  staticClass: "row align-items-center log-box collapsed",
                  attrs: {
                    id: "heading-system" + log.id,
                    "data-toggle": "collapse",
                    "data-parent": "#accordion",
                    "data-target": "#collapse-system-" + log.id,
                    "aria-controls": "#collapse-system-" + log.id
                  },
                  on: {
                    click: function($event) {
                      _vm.toggleLog(log.id)
                    }
                  }
                },
                [
                  _vm._m(0, true),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 col-md-3 col-lg-3 col-xl-3 log-description"
                    },
                    [
                      _c("p", { staticClass: "mb-0 log-description" }, [
                        _vm._v(_vm._s(log.description))
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0 log-date" }, [
                        _vm._v(_vm._s(log.date))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-7 col-md-3 col-lg-3 col-xl-3" },
                    [
                      _c("img", {
                        staticClass: "log-avatar",
                        attrs: {
                          src:
                            log.user && log.user.images && log.user.images[0]
                              ? log.user.images[0].url
                              : "/static/images/avatar.png"
                        }
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "log-name" }, [
                        _vm._v(
                          _vm._s(log.user ? log.user.first_name : "System") +
                            " " +
                            _vm._s(log.user ? log.user.last_name : "")
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-5" }, [
                    _c("span", {
                      class: {
                        "mod-icon-plus": !_vm.expandedLogs.includes(log.id),
                        "mod-icon-minus": _vm.expandedLogs.includes(log.id)
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "collapse",
                  attrs: {
                    id: "collapse-system-" + log.id,
                    "aria-expanded": "false",
                    "aria-labelledby": "heading-system-" + log.id,
                    "data-parent": "#accordion"
                  }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-1" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-11" }, [
                      _c(
                        "table",
                        { staticClass: "table m-table table-hover log-table" },
                        [
                          _vm._m(1, true),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(log.changes, function(change, key) {
                              return _c("tr", { key: "change-prefix-" + key }, [
                                _c("td", [_vm._v(_vm._s(key))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(change.old))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(change.new))])
                              ])
                            })
                          )
                        ]
                      )
                    ])
                  ])
                ]
              )
            ])
          })
        ),
        _vm._v(" "),
        _c("pagination", {
          attrs: { "change-page": _vm.changePage, meta: _vm.meta }
        })
      ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "m-table__heading" }, [
      _c("tr", [
        _c("th", [_vm._v("Property")]),
        _vm._v(" "),
        _c("th", [_vm._v("Old Value")]),
        _vm._v(" "),
        _c("th", [_vm._v("New Value")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33e2ee0b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33e2ee0b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModelLog.vue
// module id = null
// module chunks = 